import Base from './base.js'

export default class Other {
  // `responseType` indicates the type of data that the server will respond with
  // options are: 'arraybuffer', 'document', 'json' (default), 'text', 'stream'
  async get(url, config = {}) {
    return await Base.get(url, config)
  }
}
